import { getStatusDotColor } from "../../../../../utility/statusColors";
import { ChipDot } from "../../../../CardDemanda/CabecalhoCardDemanda/styles";
import { ContainerBloco, TituloBloco } from "../../../Common/styles";
import { Status } from "./styles";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface BlocoStatusProps {
    status?: string;
    loading?: boolean;
}

export default function BlocoStatus({status = '', loading = false}: BlocoStatusProps) {
    return (
        <ContainerBloco>
            {loading ? (
                <>
                    <Skeleton height={24} width="60%" style={{ marginBottom: '12px' }} />
                    <Skeleton height={32} width="100%" borderRadius={8} />
                </>
            ) : (
                <>
                    <TituloBloco>Status</TituloBloco>
                    <Status status={status}>
                        <ChipDot color={getStatusDotColor(status)} />
                        {status}
                    </Status>
                </>
            )}
        </ContainerBloco>
    )
}